// Generates a legacy-style query decoration for profile URLs, e.g. `?1K4FPGJBV=`
// We reuse the existing Base32 utility for a compact, URL-safe token.
import { toBase32 } from '@/helpers/toBase32Helper.js';

/**
 * Builds a legacy-style query string decoration for profile URLs, e.g. `?1K4FPGJBV=`,
 * using a Base32-encoded timestamp as a compact, URL-safe token.
 *
 * @returns {string} The decoration string, e.g. `?1K4FPGJBV=`.
 */
export function makeLegacyDecoration() {
  try {
    const token = toBase32(Date.now());
    return `?${token}=`;
  } catch (e) {
    // Fallback: simple base32-like via toString(32)
    return `?${Date.now().toString(32).toUpperCase()}=`;
  }
}
